import React from 'react';
import './terms.css';

function TermsAndConditions() {
  return (
    <div className="terms-container">
      <header className="terms-header">
        <h1>Terms and Conditions</h1>
        <p>Effective Date: {new Date().toLocaleDateString()}</p>
      </header>

      <main className="terms-content">
        <section className="terms-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the services provided by Community Eye Care Center ("we," "us," or "our"), 
            you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, 
            you must not use our services.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Services Provided</h2>
          <p>
            Community Eye Care Center provides comprehensive eye care services including but not limited to:
          </p>
          <ul>
            <li>Routine eye examinations</li>
            <li>Diagnosis and treatment of eye diseases</li>
            <li>Prescription of corrective lenses</li>
            <li>Surgical consultations</li>
            <li>Emergency eye care services</li>
          </ul>
          <p>
            All services are provided by licensed ophthalmologists and optometrists in accordance with 
            professional medical standards.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. Appointments and Cancellations</h2>
          <ul>
            <li>Appointments can be scheduled by phone, online, or in person</li>
            <li>We require 24 hours notice for appointment cancellations</li>
            <li>Late arrivals may result in rescheduled appointments</li>
            <li>Repeated no-shows may result in dismissal from the practice</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>4. Payment and Insurance</h2>
          <ul>
            <li>Payment is due at the time of service unless prior arrangements are made</li>
            <li>We accept most major insurance plans; please verify coverage before your visit</li>
            <li>Patients are responsible for any co-pays, deductibles, or non-covered services</li>
            <li>We accept cash, credit cards, and health savings accounts</li>
            <li>Returned checks will incur a $25 processing fee</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>5. Patient Responsibilities</h2>
          <ul>
            <li>Provide complete and accurate medical history</li>
            <li>Inform us of any changes in health status or medications</li>
            <li>Follow prescribed treatment plans</li>
            <li>Keep scheduled appointments or provide adequate cancellation notice</li>
            <li>Treat staff and other patients with respect</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>6. Prescription Policy</h2>
          <ul>
            <li>Eye prescriptions are valid for 1-2 years as determined by your eye care provider</li>
            <li>Prescription renewals require a current eye examination</li>
            <li>Contact lens prescriptions require a separate fitting and evaluation</li>
            <li>Prescriptions will not be released without a completed examination</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>7. Medical Records</h2>
          <ul>
            <li>Medical records are maintained in accordance with HIPAA regulations</li>
            <li>Records can be transferred to another provider with written authorization</li>
            <li>There may be fees associated with copying and transferring medical records</li>
            <li>Records will be retained for the minimum period required by law</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            Community Eye Care Center shall not be liable for any direct, indirect, incidental, special, 
            or consequential damages resulting from the use of or inability to use our services, even if 
            we have been advised of the possibility of such damages.
          </p>
        </section>

        <section className="terms-section">
          <h2>9. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. Changes will be effective immediately 
            upon posting on our website. Your continued use of our services constitutes acceptance of the 
            modified terms.
          </p>
        </section>

        <section className="terms-section">
          <h2>10. Governing Law</h2>
          <p>
            These Terms and Conditions shall be governed by and construed in accordance with the laws of 
            the state where our center is located, without regard to its conflict of law provisions.
          </p>
        </section>

        <section className="terms-section">
          <h2>11. Contact Information</h2>
          <address>

            Phone: 011 77 00 904<br />
            Email: communityeyecare@gmail.com<br />
            Office Hours: Monday-Friday, 8:00 AM - 5:00 PM
          </address>
        </section>
      </main>

    </div>
  );
}

export default TermsAndConditions;